<template>
  <div class="detail">

    <div :class="[isMobile ? 'detail-content-mobile' : 'detail-content']">
      <div class="detail-top">
        <img class="detail-location" src="../assets/location.png">
        <label class="detail-font" @click="returnLast()" style="cursor: pointer;color: #A05200;">{{ detailTitle
      }}</label>
        <label class="detail-font">&nbsp;&nbsp; > &nbsp;&nbsp;</label>
        <label class="detail-font">文章詳情</label>
      </div>

      <div class="detail-line"></div>

      <label class="detail-content-title">{{ detailDataItem.title }}</label>
      <label class="detail-content-title1">{{ detailDataItem.guide }}</label>
<!--      <label class="detail-content-title1">{{ detailDataItem.guide }}</label>-->
      <div v-html="detailDataItem.content" class="html-content"></div>
    </div>


  </div>
</template>


<script>

export default {
  name: 'Detail',
  data() {
    return {
      detailTitle: "",
      detailDataItem: null,
      detailContent: "",
      isMobile: false
    }
  },

  created() {
    //緩存當前頁面數據
    if (this.$route.params.data) {
      localStorage.setItem("data", JSON.stringify(this.$route.params))
    }
    //刷新頁面的時候獲取緩存數據
    let data = JSON.parse(localStorage.getItem("data"))
    if (data) {
      this.$route.params.data = data.data
      this.$route.params.type = data.type
    }
    if (this.$route.params.type == "news") {
      this.detailTitle = "最新消息"
    } else if (this.$route.params.type == "knowledge") {
      this.detailTitle = "山東歷史文化知多D"
    } else {
      this.detailTitle = "會務動態"
    }
    this.detailDataItem = this.$route.params.data

    this.detailDataItem.content = this.detailDataItem.content.replace(/<img[^>]*>/gi, function (match) {
      // match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
      // match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
      // match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');

      if (match.indexOf('style') < 0) {
        match = match.replace(/<\s*img/, '<img style="max-width:100%;"').replace(/(width="(.*?)")|(height="(.*?)")/ig, '');
      } else {
        match = match.replace(/(width="(.*?)")|(height="(.*?)")|(width:(.*?);)|(height:(.*?);)/ig, '').replace(/style=("|')/, 'style=$1max-width:100%;')
      }
      return match;
    }).replace(/<p[^>]*>/gi, function (match) {
      if (match.indexOf('style') < 0) {
        match = match.replace(/<\s*p/, '<p style="word-wrap:break-word;"');
      } else {
        match = match.replace(/style=("|')/, 'style=$1word-wrap:break-word;')
      }

      return match;
    });

    this.isMobile = window.isMobile

  },

  methods: {
    returnLast() {
      this.$router.back()
    }
  },
}
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
.detail {
  padding: 30px 0px 88px 0px;
  width: 100%;
  display: flex;
  justify-content: center;


  .detail-content {
    box-sizing: border-box;
    align-items: center;
    flex-direction: column;
    display: flex;
    background-color: white;
    border-radius: 4px;
    min-height: 979px;
    width: 1040px;

    .detail-top {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 1040px;
      padding: 15px 24px;

      .detail-location{
        width:12px;
        height:15px;
        margin-right:10px
      }
      .detail-font {
        font-size: 14px;
        color: #301E03;
      }
    }



    .detail-line {
      width: 1040px;
      height: 0.2px;
      background-color: #D9CAB2;
    }

    .detail-content-title {
      font-size: 24px;
      color: #301E03;
      margin-top: 40px
    }

    .detail-content-title1 {
      font-size: 18px;
      color: #A05200;
      margin-top: 16px
    }

    .html-content {
      width: 716px;
      margin: 16px 162px;
    }
  }

  .detail-content-mobile {
    box-sizing: border-box;
    align-items: center;
    flex-direction: column;
    display: flex;
    background-color: white;
    border-radius: 4px;
    width: 100%;
    margin: 0px 30px;


    .detail-top {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      padding: 15px 24px;
      .detail-location{
        width:12px;
        height:15px;
        margin-right:10px
      }
      .detail-font {
        font-size: 14px;
        color: #301E03;
      }
    }

    .detail-content-title {
      padding: 0px 20px;
      font-size: 20px;
      color: #301E03;
      margin-top: 20px
    }

    .detail-content-title1 {
      font-size: 18px;
      color: #A05200;
      margin-top: 8px
    }

    .detail-line {
      width: 100%;
      height: 0.2px;
      background-color: #D9CAB2;
    }

    .html-content {
      box-sizing: border-box;
      width: 100%;
      padding: 8px 16px 16px;
    }
  }





}
</style>
